export const FETCH_MAINTENANCE_DASHBOARD =
  "app/Maintenance/FETCH_MAINTENANCE_DASHBOARD";
export const FETCH_MAINTENANCE_DASHBOARD_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_DASHBOARD_SUCCESS";
export const FETCH_MAINTENANCE_DASHBOARD_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_DASHBOARD_FAILURE";

export const FETCH_MAINTENANCE_REQUESTS =
  "app/Maintenance/FETCH_MAINTENANCE_REQUESTS";
export const FETCH_MAINTENANCE_REQUESTS_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_REQUESTS_SUCCESS";
export const FETCH_MAINTENANCE_REQUESTS_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_REQUESTS_FAILURE";

export const ADD_MAINTENANCE_REQUEST =
  "app/Maintenance/ADD_MAINTENANCE_REQUEST";
export const ADD_MAINTENANCE_REQUEST_SUCCESS =
  "app/Maintenance/ADD_MAINTENANCE_REQUEST_SUCCESS";
export const ADD_MAINTENANCE_REQUEST_FAILURE =
  "app/Maintenance/ADD_MAINTENANCE_REQUEST_FAILURE";

export const FETCH_MAINTENANCE_REQUEST =
  "app/Maintenance/FETCH_MAINTENANCE_REQUEST";
export const FETCH_MAINTENANCE_REQUEST_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_REQUEST_SUCCESS";
export const FETCH_MAINTENANCE_REQUEST_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_REQUEST_FAILURE";

export const EDIT_MAINTENANCE_REQUEST =
  "app/Maintenance/EDIT_MAINTENANCE_REQUEST";
export const EDIT_MAINTENANCE_REQUEST_SUCCESS =
  "app/Maintenance/EDIT_MAINTENANCE_REQUEST_SUCCESS";
export const EDIT_MAINTENANCE_REQUEST_FAILURE =
  "app/Maintenance/EDIT_MAINTENANCE_REQUEST_FAILURE";

export const DELETE_MAINTENANCE_REQUEST =
  "app/Maintenance/DELETE_MAINTENANCE_REQUEST";
export const DELETE_MAINTENANCE_REQUEST_SUCCESS =
  "app/Maintenance/DELETE_MAINTENANCE_REQUEST_SUCCESS";
export const DELETE_MAINTENANCE_REQUEST_FAILURE =
  "app/Maintenance/DELETE_MAINTENANCE_REQUEST_FAILURE";

export const UPDATE_MAINTENANCE_REQUEST_STATUS =
  "app/Maintenance/UPDATE_MAINTENANCE_REQUEST_STATUS";
export const UPDATE_MAINTENANCE_REQUEST_STATUS_SUCCESS =
  "app/Maintenance/UPDATE_MAINTENANCE_REQUEST_STATUS_SUCCESS";
export const UPDATE_MAINTENANCE_REQUEST_STATUS_FAILURE =
  "app/Maintenance/UPDATE_MAINTENANCE_REQUEST_STATUS_FAILURE";

export const FETCH_MAINTENANCE_INSPECTIONS =
  "app/Maintenance/FETCH_MAINTENANCE_INSPECTIONS";
export const FETCH_MAINTENANCE_INSPECTIONS_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_INSPECTIONS_SUCCESS";
export const FETCH_MAINTENANCE_INSPECTIONS_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_INSPECTIONS_FAILURE";

export const ADD_MAINTENANCE_INSPECTION =
  "app/Maintenance/ADD_MAINTENANCE_INSPECTION";
export const ADD_MAINTENANCE_INSPECTION_SUCCESS =
  "app/Maintenance/ADD_MAINTENANCE_INSPECTION_SUCCESS";
export const ADD_MAINTENANCE_INSPECTION_FAILURE =
  "app/Maintenance/ADD_MAINTENANCE_INSPECTION_FAILURE";

export const FETCH_MAINTENANCE_INSPECTION =
  "app/Maintenance/FETCH_MAINTENANCE_INSPECTION";
export const FETCH_MAINTENANCE_INSPECTION_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_INSPECTION_SUCCESS";
export const FETCH_MAINTENANCE_INSPECTION_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_INSPECTION_FAILURE";

export const SUBMIT_MAINTENANCE_INSPECTION =
  "app/Maintenance/SUBMIT_MAINTENANCE_INSPECTION";
export const SUBMIT_MAINTENANCE_INSPECTION_SUCCESS =
  "app/Maintenance/SUBMIT_MAINTENANCE_INSPECTION_SUCCESS";
export const SUBMIT_MAINTENANCE_INSPECTION_FAILURE =
  "app/Maintenance/SUBMIT_MAINTENANCE_INSPECTION_FAILURE";

export const FETCH_MAINTENANCE_ASSETS =
  "app/Maintenance/FETCH_MAINTENANCE_ASSETS";
export const FETCH_MAINTENANCE_ASSETS_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_ASSETS_SUCCESS";
export const FETCH_MAINTENANCE_ASSETS_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_ASSETS_FAILURE";

export const ADD_MAINTENANCE_ASSET = "app/Maintenance/ADD_MAINTENANCE_ASSET";
export const ADD_MAINTENANCE_ASSET_SUCCESS =
  "app/Maintenance/ADD_MAINTENANCE_ASSET_SUCCESS";
export const ADD_MAINTENANCE_ASSET_FAILURE =
  "app/Maintenance/ADD_MAINTENANCE_ASSET_FAILURE";

export const FETCH_MAINTENANCE_ASSET =
  "app/Maintenance/FETCH_MAINTENANCE_ASSET";
export const FETCH_MAINTENANCE_ASSET_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_ASSET_SUCCESS";
export const FETCH_MAINTENANCE_ASSET_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_ASSET_FAILURE";

export const EDIT_MAINTENANCE_ASSET = "app/Maintenance/EDIT_MAINTENANCE_ASSET";
export const EDIT_MAINTENANCE_ASSET_SUCCESS =
  "app/Maintenance/EDIT_MAINTENANCE_ASSET_SUCCESS";
export const EDIT_MAINTENANCE_ASSET_FAILURE =
  "app/Maintenance/EDIT_MAINTENANCE_ASSET_FAILURE";

export const DELETE_MAINTENANCE_ASSET =
  "app/Maintenance/DELETE_MAINTENANCE_ASSET";
export const DELETE_MAINTENANCE_ASSET_SUCCESS =
  "app/Maintenance/DELETE_MAINTENANCE_ASSET_SUCCESS";
export const DELETE_MAINTENANCE_ASSET_FAILURE =
  "app/Maintenance/DELETE_MAINTENANCE_ASSET_FAILURE";

export const SET_ASSET_ADD_EDIT_MODAL =
  "app/Maintenance/SET_ASSET_ADD_EDIT_MODAL";

export const FETCH_MAINTENANCE_COMPLIANCE =
  "app/Maintenance/FETCH_MAINTENANCE_COMPLIANCE";
export const FETCH_MAINTENANCE_COMPLIANCE_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_COMPLIANCE_SUCCESS";
export const FETCH_MAINTENANCE_COMPLIANCE_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_COMPLIANCE_FAILURE";

export const ADD_MAINTENANCE_COMPLIANCE =
  "app/Maintenance/ADD_MAINTENANCE_COMPLIANCE";
export const ADD_MAINTENANCE_COMPLIANCE_SUCCESS =
  "app/Maintenance/ADD_MAINTENANCE_COMPLIANCE_SUCCESS";
export const ADD_MAINTENANCE_COMPLIANCE_FAILURE =
  "app/Maintenance/ADD_MAINTENANCE_COMPLIANCE_FAILURE";

export const FETCH_MAINTENANCE_COMPLIANCE_ITEM =
  "app/Maintenance/FETCH_MAINTENANCE_COMPLIANCE_ITEM";
export const FETCH_MAINTENANCE_COMPLIANCE_ITEM_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_COMPLIANCE_ITEM_SUCCESS";
export const FETCH_MAINTENANCE_COMPLIANCE_ITEM_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_COMPLIANCE_ITEM_FAILURE";

export const EDIT_MAINTENANCE_COMPLIANCE =
  "app/Maintenance/EDIT_MAINTENANCE_COMPLIANCE";
export const EDIT_MAINTENANCE_COMPLIANCE_SUCCESS =
  "app/Maintenance/EDIT_MAINTENANCE_COMPLIANCE_SUCCESS";
export const EDIT_MAINTENANCE_COMPLIANCE_FAILURE =
  "app/Maintenance/EDIT_MAINTENANCE_COMPLIANCE_FAILURE";

export const DELETE_MAINTENANCE_COMPLIANCE =
  "app/Maintenance/DELETE_MAINTENANCE_COMPLIANCE";
export const DELETE_MAINTENANCE_COMPLIANCE_SUCCESS =
  "app/Maintenance/DELETE_MAINTENANCE_COMPLIANCE_SUCCESS";
export const DELETE_MAINTENANCE_COMPLIANCE_FAILURE =
  "app/Maintenance/DELETE_MAINTENANCE_COMPLIANCE_FAILURE";

export const FETCH_MAINTENANCE_SCHEDULES =
  "app/Maintenance/FETCH_MAINTENANCE_SCHEDULES";
export const FETCH_MAINTENANCE_SCHEDULES_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_SCHEDULES_SUCCESS";
export const FETCH_MAINTENANCE_SCHEDULES_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_SCHEDULES_FAILURE";

export const ADD_MAINTENANCE_SCHEDULE =
  "app/Maintenance/ADD_MAINTENANCE_SCHEDULE";
export const ADD_MAINTENANCE_SCHEDULE_SUCCESS =
  "app/Maintenance/ADD_MAINTENANCE_SCHEDULE_SUCCESS";
export const ADD_MAINTENANCE_SCHEDULE_FAILURE =
  "app/Maintenance/ADD_MAINTENANCE_SCHEDULE_FAILURE";

export const EDIT_MAINTENANCE_SCHEDULE =
  "app/Maintenance/EDIT_MAINTENANCE_SCHEDULE";
export const EDIT_MAINTENANCE_SCHEDULE_SUCCESS =
  "app/Maintenance/EDIT_MAINTENANCE_SCHEDULE_SUCCESS";
export const EDIT_MAINTENANCE_SCHEDULE_FAILURE =
  "app/Maintenance/EDIT_MAINTENANCE_SCHEDULE_FAILURE";

export const DELETE_MAINTENANCE_SCHEDULE =
  "app/Maintenance/DELETE_MAINTENANCE_SCHEDULE";
export const DELETE_MAINTENANCE_SCHEDULE_SUCCESS =
  "app/Maintenance/DELETE_MAINTENANCE_SCHEDULE_SUCCESS";
export const DELETE_MAINTENANCE_SCHEDULE_FAILURE =
  "app/Maintenance/DELETE_MAINTENANCE_SCHEDULE_FAILURE";

export const FETCH_SCHEDULE_TEMPLATES =
  "app/Maintenance/FETCH_SCHEDULE_TEMPLATES";
export const FETCH_SCHEDULE_TEMPLATES_SUCCESS =
  "app/Maintenance/FETCH_SCHEDULE_TEMPLATES_SUCCESS";
export const FETCH_SCHEDULE_TEMPLATES_FAILURE =
  "app/Maintenance/FETCH_SCHEDULE_TEMPLATES_FAILURE";

export const ADD_SCHEDULE_TEMPLATE = "app/Maintenance/ADD_SCHEDULE_TEMPLATE";
export const ADD_SCHEDULE_TEMPLATE_SUCCESS =
  "app/Maintenance/ADD_SCHEDULE_TEMPLATE_SUCCESS";
export const ADD_SCHEDULE_TEMPLATE_FAILURE =
  "app/Maintenance/ADD_SCHEDULE_TEMPLATE_FAILURE";

export const EDIT_SCHEDULE_TEMPLATE = "app/Maintenance/EDIT_SCHEDULE_TEMPLATE";
export const EDIT_SCHEDULE_TEMPLATE_SUCCESS =
  "app/Maintenance/EDIT_SCHEDULE_TEMPLATE_SUCCESS";
export const EDIT_SCHEDULE_TEMPLATE_FAILURE =
  "app/Maintenance/EDIT_SCHEDULE_TEMPLATE_FAILURE";

export const DELETE_SCHEDULE_TEMPLATE =
  "app/Maintenance/DELETE_SCHEDULE_TEMPLATE";
export const DELETE_SCHEDULE_TEMPLATE_SUCCESS =
  "app/Maintenance/DELETE_SCHEDULE_TEMPLATE_SUCCESS";
export const DELETE_SCHEDULE_TEMPLATE_FAILURE =
  "app/Maintenance/DELETE_SCHEDULE_TEMPLATE_FAILURE";

export const SET_SCHEDULE_TEMPLATE_ADD_EDIT_MODAL =
  "app/Maintenance/SET_SCHEDULE_TEMPLATE_ADD_EDIT_MODAL";

export const SET_SCHEDULE_ADD_EDIT_MODAL =
  "app/Maintenance/SET_SCHEDULE_ADD_EDIT_MODAL";

export const ACTIVATE_ALL_PRESETS = "app/Maintenance/ACTIVATE_ALL_PRESETS";
export const ACTIVATE_ALL_PRESETS_SUCCESS =
  "app/Maintenance/ACTIVATE_ALL_PRESETS_SUCCESS";
export const ACTIVATE_ALL_PRESETS_FAILURE =
  "app/Maintenance/ACTIVATE_ALL_PRESETS_FAILURE";

export const FETCH_MAINTENANCE_LOCATION_SETTING =
  "app/Maintenance/FETCH_MAINTENANCE_LOCATION_SETTING";
export const FETCH_MAINTENANCE_LOCATION_SETTING_SUCCESS =
  "app/Maintenance/FETCH_MAINTENANCE_LOCATION_SETTING_SUCCESS";
export const FETCH_MAINTENANCE_LOCATION_SETTING_FAILURE =
  "app/Maintenance/FETCH_MAINTENANCE_LOCATION_SETTING_FAILURE";

export const SAVE_MAINTENANCE_LOCATION_SETTING =
  "app/Maintenance/SAVE_MAINTENANCE_LOCATION_SETTING";
export const SAVE_MAINTENANCE_LOCATION_SETTING_SUCCESS =
  "app/Maintenance/SAVE_MAINTENANCE_LOCATION_SETTING_SUCCESS";
export const SAVE_MAINTENANCE_LOCATION_SETTING_FAILURE =
  "app/Maintenance/SAVE_MAINTENANCE_LOCATION_SETTING_FAILURE";

export const FETCH_INSPECTION_TEMPLATES =
  "app/Maintenance/FETCH_INSPECTION_TEMPLATES";
export const FETCH_INSPECTION_TEMPLATES_SUCCESS =
  "app/Maintenance/FETCH_INSPECTION_TEMPLATES_SUCCESS";
export const FETCH_INSPECTION_TEMPLATES_FAILURE =
  "app/Maintenance/FETCH_INSPECTION_TEMPLATES_FAILURE";

export const ADD_INSPECTION_TEMPLATE =
  "app/Maintenance/ADD_INSPECTION_TEMPLATE";
export const ADD_INSPECTION_TEMPLATE_SUCCESS =
  "app/Maintenance/ADD_INSPECTION_TEMPLATE_SUCCESS";
export const ADD_INSPECTION_TEMPLATE_FAILURE =
  "app/Maintenance/ADD_INSPECTION_TEMPLATE_FAILURE";

export const EDIT_INSPECTION_TEMPLATE =
  "app/Maintenance/EDIT_INSPECTION_TEMPLATE";
export const EDIT_INSPECTION_TEMPLATE_SUCCESS =
  "app/Maintenance/EDIT_INSPECTION_TEMPLATE_SUCCESS";
export const EDIT_INSPECTION_TEMPLATE_FAILURE =
  "app/Maintenance/EDIT_INSPECTION_TEMPLATE_FAILURE";

export const DELETE_INSPECTION_TEMPLATE =
  "app/Maintenance/DELETE_INSPECTION_TEMPLATE";
export const DELETE_INSPECTION_TEMPLATE_SUCCESS =
  "app/Maintenance/DELETE_INSPECTION_TEMPLATE_SUCCESS";
export const DELETE_INSPECTION_TEMPLATE_FAILURE =
  "app/Maintenance/DELETE_INSPECTION_TEMPLATE_FAILURE";

export const CLONE_INSPECTION_TEMPLATE =
  "app/Maintenance/CLONE_INSPECTION_TEMPLATE";
export const CLONE_INSPECTION_TEMPLATE_SUCCESS =
  "app/Maintenance/CLONE_INSPECTION_TEMPLATE_SUCCESS";
export const CLONE_INSPECTION_TEMPLATE_FAILURE =
  "app/Maintenance/CLONE_INSPECTION_TEMPLATE_FAILURE";

export const SET_TEMPLATE_ADD_EDIT_MODAL =
  "app/Maintenance/SET_TEMPLATE_ADD_EDIT_MODAL";

export const ADD_INSPECTION_FROM_TEMPLATE =
  "app/Maintenance/ADD_INSPECTION_FROM_TEMPLATE";
export const ADD_INSPECTION_FROM_TEMPLATE_SUCCESS =
  "app/Maintenance/ADD_INSPECTION_FROM_TEMPLATE_SUCCESS";
export const ADD_INSPECTION_FROM_TEMPLATE_FAILURE =
  "app/Maintenance/ADD_INSPECTION_FROM_TEMPLATE_FAILURE";

export const FETCH_CQC_REPORT = "app/Maintenance/FETCH_CQC_REPORT";
export const FETCH_CQC_REPORT_SUCCESS =
  "app/Maintenance/FETCH_CQC_REPORT_SUCCESS";
export const FETCH_CQC_REPORT_FAILURE =
  "app/Maintenance/FETCH_CQC_REPORT_FAILURE";

export const FETCH_COMPLIANCE_MATRIX =
  "app/Maintenance/FETCH_COMPLIANCE_MATRIX";
export const FETCH_COMPLIANCE_MATRIX_SUCCESS =
  "app/Maintenance/FETCH_COMPLIANCE_MATRIX_SUCCESS";
export const FETCH_COMPLIANCE_MATRIX_FAILURE =
  "app/Maintenance/FETCH_COMPLIANCE_MATRIX_FAILURE";

export const FETCH_INSPECTION_REPORT =
  "app/Maintenance/FETCH_INSPECTION_REPORT";
export const FETCH_INSPECTION_REPORT_SUCCESS =
  "app/Maintenance/FETCH_INSPECTION_REPORT_SUCCESS";
export const FETCH_INSPECTION_REPORT_FAILURE =
  "app/Maintenance/FETCH_INSPECTION_REPORT_FAILURE";
